import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { shareJourney } from "../../../../redux/actions/journey";
import CardFetching from "../../../global/CardFetching/CardFetching";
import CheckboxSearch from '../../../global/CheckboxSearch/CheckboxSearch';
import ContentCard from "../../../global/ContentCard/ContentCard";
import "./CollectionShare.scss";

const CollectionShare = () => {
  const dispatch = useDispatch();
  const { playlistId } = useParams();
  const collection = useSelector(state => state.journey?.data);
  const collectionFetching = useSelector(state => state.journey?.isFetching);

  useEffect(() => {
    dispatch(shareJourney(playlistId));
  }, [dispatch, playlistId]);

  const [mediaType, setMediaType] = useState(undefined);

  const isChecked = (filter, checkboxValue) => {
    if (Array.isArray(filter)) {
      return filter.indexOf(checkboxValue) > -1;
    } else {
      return filter === checkboxValue;
    }
  };

  const toggle = (filter, updateFilter, checkboxValue, checkboxState) => {
    let newFilter = filter;
    if (Array.isArray(filter)) {
      newFilter = [...filter];
      if (checkboxState) {
        newFilter.push(checkboxValue);
      } else {
        newFilter.splice(filter.indexOf(checkboxValue), 1);
        if (newFilter.length === 0) {
          newFilter = undefined;
        }
      }
    } else {
      if (checkboxState) {
        if (!filter) {
          newFilter = checkboxValue;
        } else {
          newFilter = [checkboxValue, filter];
        }
      } else {
        newFilter = undefined;
      }
    }
    updateFilter(newFilter);
  };

  const handleShare = async () => {
    const shareData = {
      title: document.title,
      text: 'Confira isso!',
      url: window.location.href,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
        console.log('Compartilhado com sucesso!');
      } catch (err) {
        console.error('Erro ao compartilhar:', err);
      }
    } else {
      try {
        await navigator.clipboard.writeText(window.location.href);
        alert('Link copiado para a área de transferência!');
      } catch (err) {
        console.error('Erro ao copiar link:', err);
      }
    }
  };

  return (
    <div>
      <Helmet title={`${collection?.name} - Alexandria`} />
      <div className="CollectionShare">
        <div className="edit-collection-share">
          <div>
            <h2>{collection?.name}</h2>
          </div>
        </div>
        <div className="container-card-filters">
          <div className="filters">
            <div className="share-playlist">
              <button onClick={handleShare}>
                <span className="material-symbols-light--share-outline" />
                Compartilhar
              </button>
            </div>
            <div className="checkbox-div">
              <h2>Tipo do mídia</h2>
              <CheckboxSearch
                checked={isChecked(mediaType, 'AUDIO')}
                updateState={(newState) => {
                  toggle(mediaType, setMediaType, 'AUDIO', newState)
                }}
                label="Áudio"
              />
              <CheckboxSearch
                checked={isChecked(mediaType, 'VIDEO')}
                updateState={(newState) => {
                  toggle(mediaType, setMediaType, 'VIDEO', newState)
                }}
                label="Vídeo"
              />
              <CheckboxSearch
                checked={isChecked(mediaType, 'TEXT')}
                updateState={(newState) => {
                  toggle(mediaType, setMediaType, 'TEXT', newState)
                }}
                label="Texto"
              />
            </div>
          </div>

          <div className="collection-share-cards">
            {collectionFetching ? (
              <CardFetching amount={4} />
            ) : (
              collection?.contents
                ?.filter(item => {
                  if (!mediaType) return true;
                  if (Array.isArray(mediaType)) {
                    return mediaType.includes(item.mediaType);
                  }
                  return item.mediaType === mediaType;
                })
                .map((item, key) => (
                  <ContentCard item={item} key={key} />
                ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollectionShare;
